import EnumClass, { build } from '../EnumClass';
import data, { VisibilityId, VisibilityData } from './data';
import * as Translations from './translations';

export class Visibility extends EnumClass<VisibilityId, VisibilityData> {
  public get getName() {
    return Translations.name[this.id];
  }
}

export const {
  list: VISIBILITIES,
  getById: getVisibilityById,
  marshaller: VisibilityMarshaller,
  isId: isVisibilityId,
} = build<VisibilityId, VisibilityData, Visibility>('VisibilityEnum', data, Visibility);
